// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding, SmSpacing } from '@alto/design-system';
import React from 'react';

export const PartialFillActionSheet = () => {
  return (
    <ActionSheetV2
      analyticsName="med sync partial fill"
      title="Partial medication fills"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>To reduce your delivery frequency, we bundle your auto refill medications when possible.</Body>
        <SmSpacing />
        <Body>
          You might receive partial fills for some medications while we sync your deliveries, but you’ll never run out
          and you’ll only pay for what you receive until the full bundle arrives.
        </Body>
      </LgPadding>
    </ActionSheetV2>
  );
};
